// Module
var code = "<management concept=\"vm.concept\"></management>\n";
// Exports
module.exports = code;